<template>
  <!-- Empty template since this is primarily a utility component -->
</template>

<script lang="ts">
// Exporting utility functions
export function getActiveFilters(searchParams: URLSearchParams, filterKey: string): string[] {
    // Get all active filters for the given key
    if (!searchParams.has(filterKey)) return [];
    
    const value = searchParams.get(filterKey);
    if (!value) return [];
    
    // Split by comma to get multiple values
    return value.split(',');
}

export function removeFilterFromQuery(
    searchParams: URLSearchParams,
    filterKey: string,
    filterValue: string
) {
    // Get current values
    const values = getActiveFilters(searchParams, filterKey).filter(v => v !== filterValue);
    
    // Update or remove the parameter
    searchParams.delete(filterKey);
    if (values.length > 0) {
        searchParams.set(filterKey, values.join(','));
    }
}

/**
 * Alle aktive filtre, med ét skiftet ud.
 *
 * updateQueryParamsAndReload() SLETTER enhver parameter der ikke står i det
 * den får. Et filter der kun sender sit eget valg rydder derfor alle de andre.
 *
 * CheckboxFilter og MinMaxSelectFilter byggede hver sin udgave af listen. De
 * fire ovrige gjorde det ikke, og pris og lager findes i HVER kategori: satte
 * man "kun paa lager" eller roerte prisskyderen, forsvandt socket, kapacitet
 * og alt andet man havde valgt.
 *
 * Maalt i produktion: bundkort med socket AM5 gav 113 varer, og et ekstra krav
 * om "wifi" gav 131. Flere, fordi socket-valget blev slettet undervejs.
 *
 * @param urlParams de nuvaerende parametre
 * @param id        filteret der aendrer sig
 * @param vaerdi    den nye vaerdi. Tom streng fjerner filteret.
 */
export function alleAktiveFiltre(urlParams: any, id: any, vaerdi: any) {
    const p = new URLSearchParams(urlParams ? urlParams.toString() : '');

    if (vaerdi === '' || vaerdi === null || vaerdi === undefined) {
        p.delete(String(id));
    } else {
        p.set(String(id), String(vaerdi));
    }

    // Listen skal starte forfra naar filtrene aendrer sig.
    p.delete('page');

    const ud: Array<{ id: string; value: string }> = [];

    for (const [noegle, v] of p.entries()) {
        if (noegle !== 'sort' && noegle !== 'page' && v && v.trim() !== '') {
            ud.push({ id: noegle, value: v });
        }
    }

    return ud;
}

export function updateQueryParamsAndReload(tmpFilters: any) {
    // SSR check: only run in browser
    if (typeof window === 'undefined') return;

    const searchParams = new URLSearchParams(window.location.search);

    // Preserve existing sort parameter
    const currentSort = searchParams.get('sort');

    // Clear existing filter parameters
    for (const key of searchParams.keys()) {
        const filterExistsInTmpFilters = tmpFilters.some(filter => filter.id === key);
        if (!filterExistsInTmpFilters && key !== 'sort') {
            searchParams.delete(key);
        }
    }

    // Remove sort to ensure it will be added last
    searchParams.delete('sort');

    // Add new filters
    tmpFilters.forEach(filter => {
        if (filter.values && filter.values.length > 0) {
            searchParams.set(filter.id, filter.values.join(','));
        }
    });

    // Add sorting as the last parameter if it existed (ensure lowercase in URL)
    if (currentSort) {
        searchParams.append('sort', currentSort.toLowerCase());
    }

    // Update URL without reloading the page
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', newUrl);
}

// Add a default export for the component
export default {
  name: 'FilterManager',
}
</script>
